/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import { Box } from "@mui/material";

export const RenderList = React.memo(({ data }) => {
  return (
    <Box>
      <ul style={{ padding: 0 }}>
        {data?.map((item, index) => (
          <li key={index} style={{ listStyle: "none" }}>
            {item}
          </li>
        ))}
      </ul>
    </Box>
  );
});

RenderList.displayName = 'RenderList'
